import {APP_STORAGE_NAMESPACE} from "../storage/constants";

export function clearStorage() {
  [localStorage, sessionStorage].map((storage) =>
    Object.entries(storage)
    .map((item) => item[0])
    .filter(
      (item) => item.substring(0, APP_STORAGE_NAMESPACE.length) == APP_STORAGE_NAMESPACE)
    .map((item) => storage.removeItem(item))
  );
}
